import { render, staticRenderFns } from "./ScriptDialog.vue?vue&type=template&id=0270363a&scoped=true&"
import script from "./ScriptDialog.vue?vue&type=script&lang=js&"
export * from "./ScriptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270363a",
  null
  
)

export default component.exports